import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { AccountFeatures } from "@enums/account/AccountFeature";
import { IPlot } from "@interfaces/IPlot";
import { AccountFeatureService } from "@services/accountFeature.service";
import { CameraService } from "../../videos/services/camera.service";

@Component({
    selector: 'video-restriction',
    template: ''
})
export class VideoRestrictionComponent implements OnChanges {

    @Input() plot: IPlot;

    debounceTimeout: any;
    hideVideoButton: boolean;

    constructor(
        private readonly cameraService: CameraService,
        private readonly accountFeatureService: AccountFeatureService) { }

    ngOnChanges(changes: SimpleChanges) {

        this.checkRestriction();
    }

    // ---

    private checkRestriction() {

        this.hideVideoButton = !this.accountFeatureService.currentUserHasFeatureAccess(AccountFeatures.Camera) || this.plot?.videoRestricted === true;

        if (this.hideVideoButton || !this.plot.LocationInformation?.GeofenceIds?.length) { return; }
         
        this.cameraService.videoRestrictionCheck({
            VehicleId: this.plot.VehicleId,
            Length: 2,
            VideoStartTime: this.plot.UtcMoment.toDate(),
            VideoId: null,
            StreamType: null
        })
            .then(result => {
                if (!result?.CanBeRequested) {
                    this.hideVideoButton = true;
                    this.plot.videoRestricted = true;
                }
                else {
                    this.plot.videoRestricted = false;
                }
            });
        

        
    }

}
